var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.shouldShowNavBar)?_c('span',[_c('NavBar')],1):_vm._e(),_c('router-view'),(_vm.shouldShowNavBar)?_c('div',[_c('FooTer')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }